import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=1158a2cc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1158a2cc')) {
      api.createRecord('1158a2cc', component.options)
    } else {
      api.reload('1158a2cc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=1158a2cc&", function () {
      api.rerender('1158a2cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bS5Yfld3f82Y/JS/pricehelp.vue"
export default component.exports